module.exports = __webpack_public_path__ + "img/none-cover.5ad7ea4c.png";